import Link from 'next/link';
import React from 'react';

import Image from 'next/image';
import { cx } from '@emotion/css';
import { QUERY } from '@common/constants';
import { Category, Post } from '@lib/wordpress.d';
import { HOME_ROUTES } from '@util/constants';

import {
  GetPostCategories,
  GetPostDetails,
  getPostReadTime,
  GetPostTitle,
} from '../util';

type Props = {
  styles: any;
  post: Post;
  categories: Category[];
};

export const BlogMainArticle = (props: Props) => {
  const { styles, post, categories } = props;
  const yoast_head_json = post?.yoast_head_json;
  const date = new Date(post.date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  return (
    <div className={styles.blog_lg_card}>
      <div className={styles.article_card}>
        <Link
          href={`${HOME_ROUTES.BLOG_DETAILS}${QUERY}`}
          as={`${HOME_ROUTES.BLOG_DETAILS}${post.slug}`}
          className={styles.article_card_link}>
          <div className={styles.article_image}>
            <Image
              src={yoast_head_json?.og_image?.[0]?.url || '/images/blog/default.jpg'}
              alt={post.title?.rendered || 'Featured blog post'}
              className={styles.article_img}
              width={0}
              height={0}
              sizes="100vw"
              priority={true}
            />
          </div>
          <div className={styles.article_details}>
            <GetPostCategories
              categoryIds={post.categories}
              categories={categories}
              style={styles.card_tag}
            />
            <div className={styles.card_title_Arrow}>
              <h2 className={cx(styles.card_title, styles.h2)}>
                <GetPostTitle post={post} />
              </h2>
              <div className={styles.link_arrow}>
                <Image
                  src="/images/blog/list/link-arrow.svg"
                  alt="link arrow icon"
                  width={12}
                  height={12}
                  className={styles.link_arrow_img}
                />
              </div>
            </div>
            <div className={styles.card_description}>
              <GetPostDetails post={post} />
            </div>
            <div className={styles.lg_card_date_time}>
              <ul className={styles.card_date_time_ul}>
                <li className={styles.card_date_time_li}>
                  <span className={styles.card_icons}>
                    <Image
                      width={18}
                      height={18}
                      src="/images/blog/list/calendar.svg"
                      alt="calendar"
                      className={styles.card_icons_img}
                    />
                  </span>
                  {date}
                </li>
                <li className={styles.card_date_time_li}>
                  <span className={styles.card_icons}>
                    <Image
                      width={18}
                      height={18}
                      src="/images/blog/list/time.svg"
                      alt="time"
                      className={styles.card_icons_img}
                    />
                  </span>
                  {getPostReadTime({ post })}
                </li>
              </ul>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};
